/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.IQ11TokenResponse, (_params: vp.LinkBankAccountManuallyRequest) => void, () => void];

function usePostLinkBankAccountManually({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const { t } = useTranslation('translations', { keyPrefix: 'Common' });
  const [params, setParams] = useState<vp.LinkBankAccountManuallyRequest>();
  const [response, setResponse] = useState<vp.IQ11TokenResponse>({
    Success: false,
    ErrorMessage: '',
    Token: '',
  });
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.LinkBankAccountManuallyRequest) => {
      setDataFetchingInfo(true, `${t('Loading')}`, 'fullScreen');

      const res = await api.postLinkBankAccountManually(requestParams, source);

      setResponse(res);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [params]);

  return [
    response,
    (_params: vp.LinkBankAccountManuallyRequest) => {
      setParams(_params);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Token: '',
      });
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostLinkBankAccountManually);
